import { useEffect, useState } from 'react';
import './style.css';

function CustomPanelTab(props) {

    const [activeTab, setActiveTab] = useState(props?.defaultTab || props?.tabs[0]);

    useEffect(() => {
        props?.setActiveTab(activeTab);
    }, [activeTab]);

    return (
        <div className="panel-tabs">
            {
                props?.tabs?.map((tab, i) => {
                    return (
                        <div className={`panel-tab ${(tab?.name == activeTab?.name) && "pt-active"}`}>
                            <h5
                                onClick={() => {
                                    setActiveTab(tab);
                                }}
                            >{tab?.name}</h5>
                        </div>
                    )
                })
            }
        </div>
    );
}

export default CustomPanelTab;